<template>
    <div class="page">
        <div class="logo fade">
            <a href="https://samgk.ru" target="_blank"><img :src="require('@/assets/images/logo.png')" alt=""></a>
        </div>
        <div class="w-[90%] max-w-xs m-auto">
            <div class="quiz-module-card flex flex-col items-center relative fade" :class="currentQuiz.color">
                <div class="quiz-module-toolbar-image">
                    <img :src="currentQuiz.image" alt="">
                </div>
                <p class="quiz-module-card-title text-center mt-3">{{currentQuiz.title}}</p>
                <div class="quiz-module-card-body w-36 h-36 flex items-center justify-center">
                    <canvas ref="quiz_qr"></canvas>
                </div>
                <p class="quiz-module-card-description uppercase">ПРОСКАНИРУЙ МЕНЯ!</p>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
    data() {
        return {
            currentQuizID: Number(this.$route.params.id),
            currentQuiz: null,
        }
    },
    methods: {
    },
    async created() {
        let res = await this.$root.GetQuizes()
        this.currentQuiz = res[Number(this.$route.params.id)]

        if (this.currentQuiz == undefined || this.currentQuiz == null) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.currentQuiz.status == 0) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.currentQuiz.status == 2) {
            this.$router.push({name: "QuizList"})
            return
        }
    },
    mounted() {

        let link = `${location.origin}/${this.$router.resolve({name: "Quiz", params: {id: this.currentQuizID}}).href}`
        QRCode.toCanvas(this.$refs.quiz_qr, link, {version: 2, errorCorrectionLevel: 'L'})
    }
}
</script>